import { web_socket_msg_t } from "@skydio/lcm/types/skybus_tunnel/web_socket_msg_t";
import { isLcmMsg, isPbMsg, WireMsg, WireType } from "../../types";
import { Connector } from "../base";
import { ChannelDefinition } from "../types";
import WebsocketTransportLayer from "./websocket_transport_layer";
import { logger } from "../../logger";
import UseWebsocketTransportLayer from "./use_websocket_transport_layer";

export default class WebsocketConnector extends Connector {
  constructor(readonly transport: WebsocketTransportLayer | UseWebsocketTransportLayer) {
    super();
  }

  /**
   * Publish a message on a channel
   * @param {string} channel
   * @param {D extends LcmMsg} msg
   */
  public async publish<D extends WireMsg>(
    channel: string | ChannelDefinition<WireType<D>>,
    msg: D
  ) {
    const wrappedMsg = new web_socket_msg_t();
    if (typeof channel === "string") {
      wrappedMsg.channel = channel;
    } else {
      // channel is ChannelDefinition
      wrappedMsg.channel = channel.channel;
    }

    if (isPbMsg(msg)) {
      wrappedMsg.encoded_msg = new Uint8Array(msg.serializeBinary());
    } else if (isLcmMsg(msg)) {
      wrappedMsg.encoded_msg = new Uint8Array(msg.encode());
    }

    const encodedMsg = wrappedMsg.encode();

    await this.transport.sendData(encodedMsg);

    logger.log(`Published ${wrappedMsg.channel}`, msg);
  }
}
